import styled from "styled-components";
import { Divider } from "discover.medical.react-component-library";

export const StyledItemDivider = styled(Divider)`
  margin: ${({ theme }) => theme.space.sm} 0;
  margin-top: 0.75rem;
`;

export const StyledSubRegimensWrapper = styled.div`
  margin-left: ${({ theme }) => theme.space.md};
`;
